import { ImageList, Stack, Typography } from "@mui/material";
import { orderBy } from "lodash";
import { useContext, useState } from "react";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";
import { useGetAvailableEntitiesRequest } from "src/services/organizations/queries/configuration";

import PolicyContext from "../../context";
import FooterBtn from "./components/FooterBtn";
import Context from "./context";
import EntityItemBtn from "./EntityItemBtn/EntityItemBtn";

export default function EntitiesListContent() {
	const { state } = useContext(PolicyContext);
	const [entitiesSelected, setEntitiesSelected] = useState<string[]>(state.entitiesSelected);

	const { translate } = useLocales();
	const isMobile = useResponsive("down", "sm");
	const isDesktop = useResponsive("up", "md");

	const { data } = useGetAvailableEntitiesRequest();

	const itemsList = () => {
		return orderBy(data, "name").map((item) => <EntityItemBtn key={item.id} item={item} />);
	};

	return (
		<Context.Provider value={{ entitiesSelected, onSetEntities: setEntitiesSelected }}>
			<Stack sx={{ p: 3 }}>
				<Typography variant='h6'>{translate("app_config.dialog_title")}</Typography>
				<Typography variant='body2' color={"text.secondary"}>
					{translate("app_config.dialog_des")}
				</Typography>
				<ImageList cols={isDesktop ? 4 : isMobile ? 1 : 2} sx={{ mt: 2, pb: 2 }} gap={15}>
					{itemsList()}
				</ImageList>
				<FooterBtn />
			</Stack>
		</Context.Provider>
	);
}
